import React from 'react';
import EditDrawer from './EditDrawer';
import Field from '../../Field';
import { STUDENT_NOTE_MAX } from '../../../domain/people';
import s from './editStudent.module.css';

// Drawer 4 of five — the pencil on the Notes card (#120), so the note the
// wizard collects (#115) can be corrected.
//
// MMS's drawer is a plain `<textarea>` with no toolbar, no counter and no
// `maxlength`, under the caption "This note is only visible to you". Ours
// carries the bound STUDENT_NOTE_MAX derives (65,535; the arithmetic is at the
// constant) and no counter, as MMS.
//
// The caption is ours: "only visible to you" is not true of this app, which has
// admins, and the wizard says "Visible to teachers and admins, not to parents or
// students" on the same field, so both screens describe the audience alike.
export default function EditNoteDrawer({ open, form, errors, saving, onChange, onClose, onSave }) {
  if (!open) return null;

  return (
    <EditDrawer open title="Edit Note" saving={saving} onClose={onClose} onSave={onSave}>
      <Field
        label="Note"
        htmlFor="edit-note"
        hint="Visible to teachers and admins, not to parents or students"
        error={errors.note}
      >
        {/* Ten rows rather than the wizard's three: this drawer exists for
            nothing else, and MMS's is full-height with an expand control beside
            the close ✕. */}
        <textarea
          id="edit-note" rows={10} className={s.input} maxLength={STUDENT_NOTE_MAX}
          value={form.note} onChange={(e) => onChange('note', e.target.value)}
        />
      </Field>
    </EditDrawer>
  );
}
